import { Alert, Form, Switch } from 'antd'
import { FormComponentProps } from 'antd/lib/form'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './SwitchInput.module.scss'

interface IProps extends FormComponentProps {
  rules?: any[]
  label?:
    | string
    | {
        title: string
        subtitle?: string
      }
  renderLabel?: React.ReactElement
  name: string
  onChange?: any
  inputProps?: any
  isChecked?: boolean
  classInput?: any
  classLabel?: any
  locale?: {
    yesOption: string
    notOption: string
  }
  useInitialValue?: boolean
  formItemProps?: any
  helperText?: string
  onChangeAlert?: null | {
    criteria: false
    type: 'error' | 'success' | 'warning' | 'info' | undefined
    message: string
  }
}

const SwitchInput: React.FC<IProps> = ({
  form,
  formItemProps = {},
  rules = [],
  label,
  renderLabel,
  name,
  onChange,
  inputProps = {},
  isChecked = false,
  locale,
  classInput,
  classLabel,
  useInitialValue = true,
  helperText,
  onChangeAlert,
}: IProps) => {
  const { getFieldDecorator } = form
  const { t } = useTranslation()
  const [isRequired, setIsRequired] = React.useState(false)

  const isCheckedValue = form.getFieldValue(name) || isChecked
  const isTouched = form.isFieldTouched(name) || false

  React.useEffect(() => {
    if (rules && rules.length && !isRequired) {
      setIsRequired(rules.find((item) => item.required === true))
    }
  }, [rules, isRequired])

  const handlerChange = (value: any) => {
    onChange && onChange(value)
  }

  const getLabel = () => (
    <div className={`${styles.formItemLabel} ${classLabel}`}>
      {typeof label === 'string' ? (
        <p>{label}</p>
      ) : (
        <div>
          {label?.title && <p>{label?.title}</p>}
          {label?.subtitle && <small>{label?.subtitle}</small>}
        </div>
      )}
    </div>
  )

  return (
    <React.Fragment>
      <Form.Item className={`${styles.input} ${classInput}`} key={name} label={React.isValidElement(renderLabel) ? renderLabel : getLabel()} required={isRequired} {...formItemProps}>
        {getFieldDecorator(name, {
          valuePropName: 'checked',
          ...(useInitialValue ? { initialValue: !!isCheckedValue } : {}),
          rules,
        })(<Switch checkedChildren={locale?.yesOption || t('yesNotOptions.yes')} unCheckedChildren={locale?.notOption || t('yesNotOptions.not')} onChange={handlerChange} {...inputProps} />)}
      </Form.Item>
      {helperText && helperText.length && <p className={styles.helperText}>{helperText}</p>}
      {onChangeAlert?.criteria === isCheckedValue && isTouched && <Alert message={onChangeAlert?.message} type={onChangeAlert?.type} />}
    </React.Fragment>
  )
}

export default SwitchInput
